import React from "react";
import { useSelector } from "react-redux";
import ModernProfile from "./ModernProfile";
function Profil() {
  const user = useSelector((state) => state.user);
  const materii = useSelector((state) => state.materii);
  const clase = useSelector((state) => state.clase);

  return (
    <ModernProfile 
      user={user} 
      materii={materii} 
      clase={clase} 
    />
  );
}

export default Profil;
